/**
 * Mirrors `assistSettings.agentType` on the backend. SINGLE_STORE / MULTI_STORE are derived and
 * rejected with a 422 if sent; CUSTOM is the one manually settable value and marks a hand-built
 * Retell agent.
 */
export enum AgentType {
  SINGLE_STORE = 'SINGLE_STORE',
  MULTI_STORE = 'MULTI_STORE',
  CUSTOM = 'CUSTOM',
}

/** The only values a client may send. `null` hands control back to auto-derivation. */
export type WritableAgentType = AgentType.CUSTOM | null;

export const AGENT_TYPE_LABELS: Record<AgentType, string> = {
  [AgentType.SINGLE_STORE]: 'Single Store',
  [AgentType.MULTI_STORE]: 'Multi Store',
  [AgentType.CUSTOM]: 'Custom',
};

/** Single vs multi store is not a choice, so the admin only picks auto-managed vs hand-built. */
export enum AgentTypeMode {
  AUTOMATIC = 'AUTOMATIC',
  CUSTOM = 'CUSTOM',
}
